
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M23 33l2.8-4H18l2 4zM13 5l5 24h6.87L17 5z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M8 29h16.113a1 1 0 00.948-1.316l-7.333-22A1 1 0 0016.779 5H8a3 3 0 00-3 3v18a3 3 0 003 3z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M19 11h14a3 3 0 013 3v16a3 3 0 01-3 3H20.78a1 1 0 01-.97-.757L19 29"}}),_c('path',{attrs:{"fill":"#2196F3","d":"M12 12h2v2h-2z"}}),_c('path',{attrs:{"stroke":"#2196F3","stroke-width":"2","d":"M10.5 18.5h5M25 17h8m-4 0v-2.5m-4 11c3.333-2 5-4.833 5-8.5m-4 2.5c.333 3 2.333 5 6 6M13 12.4l-3.51 9.105M13 12.4l3.51 9.081"}})])])
          )
        }
      }
    